import { Scholarship } from './scholarship';

export class ScholarshipSearchOutcome {
	public constructor(
		public readonly scholarships: readonly Scholarship[],
		public readonly hitsTotal: number,
		public readonly hitsTotalExact: boolean
	) {}
}
